<template>
  <accordion-item
      :loading="isLoading"
      :initially-expanded="initially_expanded"
      :key="uuid"
      ref='shipmentRef'
  >
    <template v-slot:header>
      <h3 :class="['title', name ? 'title-shrink' : '']">
        {{ `Shipment ${meta ?? '#' + (shipmentNumber + 1)}` }}
        <svg :width="[name ? 15 : 25]"
             :height="[name ? 12.6 : 21]"
             viewBox="0 0 25 21"
             fill="none"
             xmlns="http://www.w3.org/2000/svg"
        >
          <path fill="#555555"
                d="M4.375 0.5H14.375C15.3906 0.5 16.25 1.35938 16.25 2.375V4.25H18.2031C18.8672 4.25 19.4922 4.52344 20 4.99219L23.0078 8C23.4766 8.46875 23.75 9.13281 23.75 9.79688V14.25C24.4141 14.25 25 14.8359 25 15.5C25 16.2031 24.4141 16.75 23.75 16.75H22.5C22.5 18.8203 20.8203 20.5 18.75 20.5C16.6406 20.5 15 18.8203 15 16.75H10C10 18.8203 8.32031 20.5 6.25 20.5C4.14062 20.5 2.5 18.8203 2.5 16.75V11.75H8.125C8.4375 11.75 8.75 11.4766 8.75 11.125C8.75 10.8125 8.4375 10.5 8.125 10.5H0.625C0.273438 10.5 0 10.2266 0 9.875C0 9.5625 0.273438 9.25 0.625 9.25H9.375C9.6875 9.25 10 8.97656 10 8.625C10 8.3125 9.6875 8 9.375 8H1.875C1.52344 8 1.25 7.72656 1.25 7.375C1.25 7.0625 1.52344 6.75 1.875 6.75H10.625C10.9375 6.75 11.25 6.47656 11.25 6.125C11.25 5.8125 10.9375 5.5 10.625 5.5H0.625C0.273438 5.5 0 5.22656 0 4.875C0 4.5625 0.273438 4.25 0.625 4.25H2.5V2.375C2.5 1.35938 3.32031 0.5 4.375 0.5ZM21.25 9.79688L18.2031 6.75H16.25V10.5H21.25V9.79688ZM6.25 18.625C7.26562 18.625 8.125 17.8047 8.125 16.75C8.125 15.7344 7.26562 14.875 6.25 14.875C5.19531 14.875 4.375 15.7344 4.375 16.75C4.375 17.8047 5.19531 18.625 6.25 18.625ZM20.625 16.75C20.625 15.7344 19.7656 14.875 18.75 14.875C17.6953 14.875 16.875 15.7344 16.875 16.75C16.875 17.8047 17.6953 18.625 18.75 18.625C19.7656 18.625 20.625 17.8047 20.625 16.75Z"
          />
        </svg>
      </h3>
      <div style="display: flex;align-items: center;gap: 10px;">
        <h3 v-if="name" class="name">{{ name }}</h3>
        <span v-if="rates && rates.length"> - <a
            @click.prevent="() => deleteRates(orderUuid)"
            style="text-decoration: underline"
            href="#"
        >{{ location }} <svg xmlns="http://www.w3.org/2000/svg" height="10px" viewBox="0 0 512 512"><path
            fill="#BF2C33"
            d="M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32zM362.7 18.7L348.3 33.2 325.7 55.8 314.3 67.1l33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5L453.3 18.7c-25-25-65.5-25-90.5 0zm-47.4 168l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
        /></svg></a></span>
      </div>
      <div>{{ selectedRateName }}</div>
    </template>
    <template v-slot:body>
      <div class="shipment">
        <shipment-form-fields
          v-show="!rates?.length"
          :order-uuid="orderUuid"
          :uuid="uuid"
          :loading="isLoading"
          :is-logged-in="isLoggedIn"
          v-on:save-package-preset="(args) => $emit('save-package-preset', args)"
          v-on:toggle-preset-modal="(args) => $emit('toggle-preset-modal', args)"
        ></shipment-form-fields>

        <shipping-rates :shipment-id="uuid" v-if="rates?.length" :rates="rates"></shipping-rates>

        <a href="#" @click.prevent="() => deleteShipment(uuid)" class="delete">
          <svg width="16" height="19" viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.75 14.8125C5.75 15.1289 5.46875 15.375 5.1875 15.375C4.87109 15.375 4.625 15.1289 4.625 14.8125V7.5C4.625 7.21875 4.87109 6.9375 5.1875 6.9375C5.46875 6.9375 5.75 7.21875 5.75 7.5V14.8125ZM8.5625 14.8125C8.5625 15.1289 8.28125 15.375 8 15.375C7.68359 15.375 7.4375 15.1289 7.4375 14.8125V7.5C7.4375 7.21875 7.68359 6.9375 8 6.9375C8.28125 6.9375 8.5625 7.21875 8.5625 7.5V14.8125ZM11.375 14.8125C11.375 15.1289 11.0938 15.375 10.8125 15.375C10.4961 15.375 10.25 15.1289 10.25 14.8125V7.5C10.25 7.21875 10.4961 6.9375 10.8125 6.9375C11.0938 6.9375 11.375 7.21875 11.375 7.5V14.8125ZM11.2695 1.62891L12.5703 3.5625H15.0312C15.4883 3.5625 15.875 3.94922 15.875 4.40625C15.875 4.89844 15.4883 5.25 15.0312 5.25H14.75V15.9375C14.75 17.5195 13.4844 18.75 11.9375 18.75H4.0625C2.48047 18.75 1.25 17.5195 1.25 15.9375V5.25H0.96875C0.476562 5.25 0.125 4.89844 0.125 4.40625C0.125 3.94922 0.476562 3.5625 0.96875 3.5625H3.39453L4.69531 1.62891C5.04688 1.10156 5.67969 0.75 6.34766 0.75H9.61719C10.2852 0.75 10.918 1.10156 11.2695 1.62891ZM5.43359 3.5625H10.5312L9.86328 2.57812C9.82812 2.50781 9.72266 2.4375 9.61719 2.4375H6.34766C6.24219 2.4375 6.13672 2.50781 6.10156 2.57812L5.43359 3.5625ZM2.9375 15.9375C2.9375 16.5703 3.42969 17.0625 4.0625 17.0625H11.9375C12.5352 17.0625 13.0625 16.5703 13.0625 15.9375V5.25H2.9375V15.9375Z"
                  fill="#5A5A5A"
            />
          </svg>
          Delete Shipment</a>
      </div>
    </template>
  </accordion-item>
</template>

<style scoped>
.shipment {
  scroll-margin-top: 75px;
}

.delete {
  display: inline-block;
  color: #5A5A5A;
  gap: 8px;
}
</style>

<script>
import {useLoadingStore} from "../stores/loading";
import {useShipmentStore} from "../stores/shipment";
import {storeToRefs} from "pinia";
import ShippingRates from "./ShippingRates.vue";
import ShipmentFormFields from "./ShipmentFormFields.vue";
import {useOrderStore} from "../stores/order";

export default {
  setup(props) {
    const useOrder = useOrderStore();
    const {deleteShipment} = useOrder;

    const useShipment = useShipmentStore(props.uuid);
    const {deleteRates} = useShipment;
    const {
      rates,
      initially_expanded,
      uuid,
      meta,
      location,
      selectedRateName,
        name,
    } = storeToRefs(useShipment);

    const useLoading = useLoadingStore();
    const {isLoading} = storeToRefs(useLoading);

    return {
      isLoading,
      deleteShipment,
      deleteRates,
      rates,
      initially_expanded,
      uuid,
      meta,
      location,
      selectedRateName,
      name,
    }
  },
  components: {
    ShippingRates,
    ShipmentFormFields
  },
  props: {
    isLoggedIn: {
      type: Boolean,
      required: true
    },
    shipmentNumber: Number,
    uuid: {
      type: String,
      required: true
    },
    orderUuid: {
      type: String,
      required: true
    }
  },
  data: () => ({}),
  computed: {},
  watch: {
    rates: {
      handler: function (newVal, oldVal) {
        if (newVal?.length != oldVal?.length) {
          this.$refs?.shipmentRef?.scrollIntoView({block: "start", behavior: 'smooth'});
        }
      },
      deep: true
    }
  }
}
</script>
